import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import IncutPromoBlock from 'components/IncutPromoBlock';
import SectionLayout from 'components/SectionLayout';
import Layout from 'components/Layout';

import CommonPropTypes from 'utils/propTypes/common';

import ActualPromoBlocks from './components/ActualPromoBlocks';
import Catalog from './components/Catalog';
import Counters from './components/Counters';
import MoviesByTypes from './components/MoviesByTypes';
import StreamingPlatforms from './components/StreamingPlatforms';

const NationalStreaming = ({
	rubric,
	blocks: { bannerPromoBlock, topicalPromoBlock, nationalStreamingCounters },
	actualMovies,
	archiveMovies,
	moviesByTypes,
	streamingPlatforms,
	counters
}) => (
	<Layout rubric={rubric}>
		<SectionLayout gutter={_.isEmpty(topicalPromoBlock?.entities) && 'bottom'}>
			{!_.isEmpty(counters) && (
				<Counters {...{ counters, nationalStreamingCounters }} />
			)}
			{!_.isEmpty(bannerPromoBlock?.entities) && (
				<IncutPromoBlock
					key="IncutPromoBlock"
					{...bannerPromoBlock.entities[0]}
				/>
			)}
			{(!_.isEmpty(actualMovies) || !_.isEmpty(archiveMovies)) && (
				<Catalog
					key="Catalog"
					actualMovies={actualMovies}
					archiveMovies={archiveMovies}
				/>
			)}
			{moviesByTypes && (
				<MoviesByTypes key="MoviesByTypes" movies={moviesByTypes} />
			)}
			{!_.isEmpty(streamingPlatforms) && (
				<StreamingPlatforms
					key="StreamingPlatforms"
					streamingPlatforms={streamingPlatforms}
				/>
			)}
			{!_.isEmpty(topicalPromoBlock?.entities) && (
				<ActualPromoBlocks
					key="ActualPromoBlocks"
					promoBlocks={topicalPromoBlock?.entities}
				/>
			)}
		</SectionLayout>
	</Layout>
);

NationalStreaming.propTypes = {
	rubric: CommonPropTypes.rubric,
	blocks: PropTypes.shape({
		bannerPromoBlock: PropTypes.object,
		topicalPromoBlock: PropTypes.object,
		nationalStreamingCounters: PropTypes.object
	}),
	actualMovies: CommonPropTypes.entities,
	archiveMovies: CommonPropTypes.entities,
	moviesByTypes: PropTypes.objectOf(CommonPropTypes.entities),
	streamingPlatforms: CommonPropTypes.entities,
	counters: PropTypes.object
};

export default NationalStreaming;
